export default {
  en: "English (انجليزي)",
  ar: "Arabic (عربي)",
  ur: "Urdu (اردو)",
}
